import React, {useState, useEffect, useRef, useContext} from "react";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {functions} from "../../../constants/common-functions";
import {COLOR_UTILISATION_OCCUPIED} from "../../../constants/colors";
import {COLOR_UTILISATION_SIGNS_OF_LIFE} from "../../../constants/colors";
import {COLOR_UTILISATION_VACANT} from "../../../constants/colors";
import AmChartSimpleColumn from "../../../components/AmChartSimpleColumn";
import {COLOR_GRAY_BANNER_BACKGROUND} from "../../../constants/general-constants";
import {TRUE} from "../../../constants/general-constants";
import {CHART_CONTAINER_STYLE} from "../../../constants/styles";
import PillButton from "../../../components/PillButton";
import {store} from '../../../context/store';

export default function UtilisationChartProfileUnused({id, isMeeting, filterBean}){
	
	const [chartIndex, setChartIndex] = useState(0);
	const [chartData, setChartData] = useState([]);
	
	const globalState = useContext(store);
	
	const queryContext =
		 globalState?.state?.queryContext;
	
	const charts = [
		{index:0, title:"Weekly Profile", urlDesks:"utilisationgetavgbydowwithoutfilter", urlMeeting:"utilisationgetavgbydowwithoutfilter", color:COLOR_UTILISATION_OCCUPIED},
		{index:1, title:"Daily Profile", urlDesks:"utilisationgetavgbyhourwithoutfilter", urlMeeting:"utilisationgetavgbyhourmeetingwithoutfilter", color:COLOR_UTILISATION_OCCUPIED},
		{index:2, title:"Unused", urlDesks:"utilisationstandardgetunusedbyday", urlMeeting:"utilisationstandardgetunusedbyday", color:COLOR_UTILISATION_VACANT}
	];
	
	useEffect(() => {
		loadChartData();
	}, [id, queryContext?.utilisationSurveyId, chartIndex, filterBean]);
	
	
	const loadChartData = () => {

	    let url = charts[chartIndex].urlDesks;

	    if(isMeeting === TRUE){
	        url = charts[chartIndex].urlMeeting;
	    }

	    functions.postFilterBeanAjax(
	        "/resolutionsoftwareplatform/" + url,
	        functions.buildPostBodyFilterBeanQueryContext(filterBean, queryContext),
	        handleData
	    );
	};
	
	const getDOW = (index) => {
		let days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sun'];
		return days[parseInt(index)];
	};
	
	const handleData = (results) => {
		if(chartIndex === 0){
			const tempData = results.map(({label, avg }) => ({
		    id:label,
		    label:getDOW(label),
		    value: avg,
		  }));
	  	setChartData(tempData);
		}
		else if(chartIndex === 2){
			const tempData = results.map(({groupBy, returnDouble }) => ({
		    id:groupBy,
		    label:groupBy,
		    value:returnDouble
		  }));
		  setChartData(tempData);
		}
		else{
			const tempData = results.map(({label, avg }) => ({
		    id:label,
		    label,
		    value: avg,
		  }));
	  	setChartData(tempData);
		}
	};
	
	const thisContainer = {
		display:"flex",
		width:"100%",
		flexDirection:"column",
		height:"100%"
	};
	
	const chartContainer = {
		display:"flex",
		width:"100%",
		height:"calc(100% - 50px)",
		marginTop:"-10px"
	}
	
	const titleContainer = {
		display:"flex",
		fontSize:"14px",
		height:"30px",
		alignItems:"center",
		alignSelf:"center",
		paddingTop:"20px"
	};
	
	
	const switchChartIndex = (index) => {
		setChartIndex(index);
	}
	
	const getTitleDisplay = (item, index) => {
		if(index === chartIndex){
			return <PillButton
			    isActive={true}
			    id={index}
				label={item.title}
				onClick={() => {switchChartIndex(index)}}
			/>;
			
		}
		else{
			return <PillButton
			    isActive={false}
			    id={index}
				label={item.title}
				onClick={() => {switchChartIndex(index)}}
			/>;
		}
	}
	
	const titleDisplay = charts.map((item, index) =>
		getTitleDisplay(item, index)
	);
	
	const getChartColor = () => {
		return charts[chartIndex].color;
	};
	
	return (
		<div style={thisContainer}>
			<div style={chartContainer}>
				<div style={CHART_CONTAINER_STYLE}>
			
				<AmChartSimpleColumn
				 	chartId={id}
				 	chartData={chartData}
				 	categoryKey="label"
				 	valueKey="value"
				 	color={getChartColor()}
				 	width="100%"
				 	height="calc(100% - 0px)"
					/>
				</div>
			</div>
			<div style={titleContainer}>
				{titleDisplay}
			</div>
		</div>
	);
}